"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const partners = [{
  name: "Ordem dos Advogados",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/Ordem_dos_Advogados.png"
}, {
  name: "Gondoclássicos",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/307734056_460898716071874_2206181939581890526_n.png"
}, {
  name: "Rancho Folclórico de Zebreiros",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/unnamed.png"
}, {
  name: "Centro de Estudos Dona Sebentinha",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/images.png"
}, {
  name: "Associação Nacional Táxis de Portugal",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/profile-picture168x168px_Prancheta-1.png"
}, {
  name: "Universidade Sénior Gondomar",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/646979929_1551330916993442_2347218450516664677_n.png"
}, {
  name: "Misericórdias Saúde",
  logo: "https://clinica-santa-cruz.pt/wp-content/uploads/2026/06/images-1.png?v=v7gdowk6zbs"
}];
export default function OurPartners() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: carouselRef,
    isVisible: isCarouselVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="os-nossos-parceiros" className="relative w-full py-24 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/gondomar_topographic_map_pattern.png)] bg-cover bg-center bg-no-repeat mix-blend-multiply" />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 tracking-tight">
            Os Nossos Parceiros
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Orgulhamo-nos de colaborar com diversas entidades para oferecer benefícios e serviços de excelência à comunidade de Gondomar e arredores.
          </p>
        </div>

        <div ref={carouselRef} className={`transition-all duration-1000 delay-200 ease-out ${isCarouselVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full max-w-7xl mx-auto">
            <CarouselContent className="-ml-4 md:-ml-6">
              {partners.map((partner, index) => <CarouselItem key={index} data-index={index} className="pl-4 md:pl-6 basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
                  <div className="p-1 h-full">
                    <Card className="h-full bg-card border-t-4 border-t-primary shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center justify-center p-8 text-center group">
                      <CardContent className="p-0 flex flex-col items-center justify-center gap-6 w-full">
                        <div className="w-24 h-24 relative flex items-center justify-center bg-accent/50 rounded-lg overflow-hidden group-hover:scale-105 transition-transform duration-500">
                          <img src={partner.logo} alt={`Logotipo ${partner.name}`} className="w-16 h-16 object-contain opacity-80 group-hover:opacity-100 transition-opacity duration-300" loading="lazy" />
                        </div>
                        <h3 className="font-serif font-bold text-lg md:text-xl text-foreground leading-tight">
                          {partner.name}
                        </h3>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="bg-background/80 backdrop-blur-sm border-border hover:bg-primary hover:text-primary-foreground transition-colors" />
              <CarouselNext className="bg-background/80 backdrop-blur-sm border-border hover:bg-primary hover:text-primary-foreground transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}